<!-- P/detail.html:888: nav.crumb > a.back (glyph + label) / b[aria-current]; ancestors are buttons, as P/06_career-explorer.html:1574. -->
<nav class="agu-crumb" aria-label="Breadcrumb">
    @for (item of Trail; track $index; let first = $first) {
        @if (item.Location) {
            <button type="button" class="agu-crumb__link" [attr.aria-label]="AriaLabel(item)" (click)="Go(item)">
                @if (first) {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M19 12H5" />
                        <path d="m11 6-6 6 6 6" />
                    </svg>
                }
                <span>{{ item.Label }}</span>
            </button>
            <span class="agu-crumb__sep" aria-hidden="true">/</span>
        } @else {
            <b class="agu-crumb__current" aria-current="page">{{ item.Label }}</b>
        }
    }
</nav>
